import { createRouter, createWebHistory } from "vue-router";
import { Firebase } from "../../src/utils/firebase-utility";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "ログイン",
      meta: { isLoginedOnly: false, isAnonymousOnly: true, showNavigationMenu: false },
      component: () => import("./views/login/login-view.vue"),
      props: true,
    },
    {
      path: "/",
      name: "ホーム",
      meta: { isLoginedOnly: true, isAnonymousOnly: false, showNavigationMenu: true },
      component: () => import("./views/home/home-view.vue"),
      props: true,
    },
    {
      path: "/organizations",
      name: "組織管理",
      meta: { isLoginedOnly: true, isAnonymousOnly: false, showNavigationMenu: true },
      component: () => import("./views/organizations/organizations-view.vue"),
      props: true,
      children: [
        {
          path: ":organizationId",
          name: "組織詳細",
          component: () => import("./views/organizations/organization-view.vue"),
          props: true,
        },
      ],
    },
    {
      path: "/:path(.*)",
      redirect: { path: "/", replace: true },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const isLoginedOnly = to.matched.some((record) => record.meta.isLoginedOnly ?? true);
  const isAnonymousOnly = to.matched.some((record) => record.meta.isAnonymousOnly);

  // ログインページログイン状態を見る必要がなければ即時表示
  if (!isLoginedOnly && !isAnonymousOnly) {
    next();
    return;
  }

  const isLogined = await Firebase.logined;

  // ログイン済なのにログインページ表示しようとしてたらホームか、指定遷移先に遷移
  if (isLogined && isAnonymousOnly) {
    if (to.query.redirect) {
      next({ path: to.query.redirect as string });
    } else {
      next({ path: "/" });
    }
    return;
  }

  // ログイン必須ページなのにログインしていないなら、ログインページへ遷移
  if (isLoginedOnly && !isLogined) {
    next({ path: "/login", query: { redirect: to.fullPath, ...to.query } });
    return;
  }

  next();
});

export default router;
